// Печатная версия отчёта «Учёба за рубежом» — пять листов A4 без меню и
// подвала сайта. Открывается по той же ссылке гостя (токен), печатается
// браузером в PDF. noindex: в ней имя ребёнка и ответы анкеты.

import { useEffect, useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";

import { AbroadReport5 } from "@/components/abroad/AbroadReport5";
import { getAbroadReport5, type AbroadReport5View } from "@/lib/abroad-report5.functions";

export const Route = createFileRoute("/abroad-report/$token")({
  head: () => ({
    meta: [{ title: "Yolutap — Study abroad report" }, { name: "robots", content: "noindex, nofollow" }],
  }),
  component: AbroadReportPrintPage,
});

function AbroadReportPrintPage() {
  const { token } = Route.useParams();
  const fetchReport = useServerFn(getAbroadReport5);
  const [view, setView] = useState<AbroadReport5View | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true;
    fetchReport({ data: { token, surface: "print" } })
      .then((v) => alive && setView(v))
      .catch(() => alive && setFailed(true));
    return () => {
      alive = false;
    };
  }, [fetchReport, token]);

  if (failed || (view && (!view.found || !view.completed)))
    return <p style={{ padding: 24, fontFamily: "system-ui" }}>Report not found.</p>;
  if (!view) return null;
  return (
    <div data-print-ready="1" style={{ background: "#FBFAF7" }}>
      <AbroadReport5 model={view.model} mode="print" />
    </div>
  );
}
